class ContentScroller {
  constructor(container, eventBus) {
    this.container = container;
    this.eventBus = eventBus;
    this.scrollContent = this.container.querySelector('.scroll-content');
    this.windowHeight = window.innerHeight;
    this.contentPosition = -(this.windowHeight / 2);

    this.handleResize = this.handleResize.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.init();
  }

  init() {
    this.bindEventListeners();
    // set initial transform
    this.scrollContent.style.transform = `translateY(${this.contentPosition}px)`;
  }

  bindEventListeners() {
    this.eventBus.subscribe('resize', this.handleResize);
    this.eventBus.subscribe('scrollPosition', this.handleScroll);
  }

  handleScroll(scrollTop) {
    const newPos = scrollTop < this.windowHeight ? this.contentPosition + (scrollTop / 2) : 0;
    this.scrollContent.style.transform = `translateY(${newPos}px)`;
  }

  handleResize({ width, height }) {
    this.windowHeight = height;
    this.contentPosition = -(height / 2);
  }
}

export default ContentScroller;